import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ICustomerAddress } from 'src/core/interfaces/customerAddress';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  private _baseUrl = `${environment.apiURL}/api`;

  constructor(private http: HttpClient) { }

  getAllCustomers() {
    return this.http.get<any>(`${this._baseUrl}/customer?isActive=1`);
  }

  getCustomerById(id: number) {
    return this.http.get<any>(`${this._baseUrl}/customer/${id}`);
  }

  getCustomers(pageIndex = 0, pageSize = 10, pagination = false, criteria = null) {
    return this.http.get<any>(`${this._baseUrl}/customer/paginated?pageIndex=${pageIndex}&pageSize=${pageSize}&pagination=${pagination}${criteria != null ? "&criteria="+criteria : ""}`);
  }

  getLastSapSync(){
    return this.http.get<any>(`${this._baseUrl}/customer/LastSyncDate`);
  }

  
  updateCustomers(){
    return this.http.get<any>(`${this._baseUrl}/customer/sync`);
  }

  addCustomer(createCustomerVM) {
    const form = new FormData();
    form.append("firstName", createCustomerVM.firstName);
    form.append("lastName", createCustomerVM.lastName);
    form.append("email", createCustomerVM.email);
    form.append("userName", createCustomerVM.username);
    form.append("Password", createCustomerVM.password);
    form.append("confirmPassword", createCustomerVM.confirmPassword);
    form.append("image", createCustomerVM.image);
    form.append("nationality", createCustomerVM.nationality);
    form.append("addressName", createCustomerVM.addressName);
    form.append("street", createCustomerVM.street);
    form.append("city", createCustomerVM.city);
    form.append("buildingNumber", createCustomerVM.buildingNumber);
    form.append("sAPCustomerId", createCustomerVM.sAPCustomerId);
    form.append("googleLocation", createCustomerVM.googleLocation);
    for (const index in createCustomerVM.roles) 
    {
      form.append(`RolesString[${index}]`,JSON.stringify(createCustomerVM.roles[index]));
    }
    for (const index in createCustomerVM.warehouses) 
    {
      form.append(`Warehouses[${index}]`,JSON.stringify(createCustomerVM.warehouses[index]));
    }
    for (const index in createCustomerVM.products) 
    {
      form.append(`Products[${index}]`,JSON.stringify(createCustomerVM.products[index]));
    }
    return this.http.post<any>(`${this._baseUrl}/customer/add`,form);
  }

  updateCustomer(id, createCustomerVM) {
    // console.log(id);
    const form = new FormData();
    form.append("id", createCustomerVM.id);
    form.append("firstName", createCustomerVM.firstName);
    form.append("lastName", createCustomerVM.lastName);
    form.append("email", createCustomerVM.email);
    form.append("userName", createCustomerVM.username);
    form.append("Password", createCustomerVM.password);
    form.append("confirmPassword", createCustomerVM.confirmPassword);
    form.append("image", createCustomerVM.image);
    form.append("nationality", createCustomerVM.nationality);
    form.append("addressName", createCustomerVM.addressName);
    form.append("street", createCustomerVM.street);
    form.append("city", createCustomerVM.city);
    form.append("buildingNumber", createCustomerVM.buildingNumber);
    form.append("sAPCustomerId", createCustomerVM.sAPCustomerId);
    form.append("googleLocation", createCustomerVM.googleLocation);
    for (const index in createCustomerVM.roles) 
    {
      form.append(`RolesString[${index}]`,JSON.stringify(createCustomerVM.roles[index]));
    }
    for (const index in createCustomerVM.warehouses) 
    {
      form.append(`Warehouses[${index}]`,JSON.stringify(createCustomerVM.warehouses[index]));
    }
    for (const index in createCustomerVM.products) 
    {
      form.append(`Products[${index}]`,JSON.stringify(createCustomerVM.products[index]));
    }
    return this.http.post<any>(`${this._baseUrl}/customer/edit/${id}`,form);
  }
  setCustomerLocation(customerLocation){
    return this.http.post<any>(`${this._baseUrl}/customer`, customerLocation);
  }

  createCustomerUserAccount(customerId: number, userData: {
    userName: string;
    email: string;
    password: string;
    confirmPassword: string;
    roleId:string;
  }) {
    // Send as JSON instead of FormData
    return this.http.post<any>(
      `${this._baseUrl}/customer/CreateCustomerPortalUser/${customerId}`, 
      userData, 
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
  }

  updateCustomerAddresses(customerId: number,customerAddresses: ICustomerAddress[]) {   
    return this.http.post<any>(`${this._baseUrl}/customer/UpdateCustomerAddresses/${customerId}`, customerAddresses);
  }

  getCustomerFinancialStatment(
    id: number,
    dateFrom: Date,
    dateTo: Date
  ) : Observable<any> {
    // // debugger;
    const url = `${this._baseUrl}/customer/GetCustomerFinancialStatment/${id}`;
    const params = new HttpParams()
      .set('dateFrom', dateFrom.toISOString())
      .set('dateTo', dateTo.toISOString());

    return this.http.get(url, { params });
  }

  getCustomerAccountDetails(
    id: number,
    dateFrom: Date,
    dateTo: Date
  ): Observable<any> {
    // // debugger;
    //const url = `${this._baseUrl}/customer/CustomerAccountDetails`;

    const url= `${this._baseUrl}/Report/Customer/CustomerAccountDetails`
    const params = new HttpParams()
      .set('customerId', id.toString()) 
      .set('dateFrom', dateFrom.toISOString().split('T')[0])
      .set('dateTo', dateTo.toISOString().split('T')[0]);
  
      
    return this.http.get(url, { params });
  }
  

  getCustomerSalesItemsDetails(
    id: number,
    dateFrom: Date,
    dateTo: Date,
    itemFrom:any,
    itemTo:any,
  ): Observable<any> {
    // // debugger;
    //const url = `${this._baseUrl}/customer/CustomerAccountDetails`;

    const url= `${this._baseUrl}/Report/Customer/CustomerSalesDetails`
    let params = new HttpParams()
      .set('customerId', id.toString()) 
      .set('dateFrom', dateFrom.toISOString().split('T')[0])
      .set('dateTo', dateTo.toISOString().split('T')[0]);
  
      if (itemTo) {
        params = params.set('itemTo', itemTo);
      }
      
      if (itemFrom) {
        params = params.set('itemFrom', itemFrom);
      }

    return this.http.get(url, { params });
  }
}
